module.exports = __webpack_public_path__ + "img/TotalStock.cc1503ea.png";